import { formatCurrency } from "src/helpers";
import { getStatusStyles } from "src/helpers/billingHelper";
import { classNames } from "src/helpers/classNames";
import moment from "moment";
import { CalendarIcon } from "@heroicons/react/24/solid";
import InformationAlert from "src/components/Shared/Alerts/InformationAlert";

export const PlanCard = ({ plan, status, isUpcoming }) => {
  if (!plan) return null;

  const { className, label } = getStatusStyles(isUpcoming && plan?.payment_status === "succeeded" ? "active" : status);
  const selectedRate = plan?.plan_details?.pricing?.rates?.find((rate) => rate?.interval === plan?.subscription?.recurring_type);

  const pricePerInterval = formatCurrency(((selectedRate?.amount || 0) - (selectedRate?.discount_amount || 0)) / (plan?.subscription?.recurring_type === "year" ? 12 : 1));
  const totalPrice = selectedRate ? selectedRate.amount : 0;
  const discountedPrice = totalPrice - (selectedRate?.discount_amount || 0);

  return (
    <div className="flex flex-col gap-y-4 ">
      <div className="w-full rounded-md border p-4 pb-2">
        <div className="flex w-full items-center gap-2 text-2xl font-semibold">
          {plan?.plan_details?.name}
          <div className={classNames("flex h-8 items-center justify-center gap-2 rounded-lg border bg-white px-2 text-base", className)}>{label}</div>
        </div>
        <div className="py-1 pl-0.5 text-sm opacity-75">
          <div dangerouslySetInnerHTML={{ __html: plan?.plan_details?.description || "No Description" }}></div>
        </div>

        <div className="relative my-2 flex w-full flex-col gap-4 rounded-md border p-3">
          {selectedRate?.discount_type !== "none" && <div className="absolute right-0 top-0 rounded-bl-lg bg-slate-200 p-1.5 text-sm">{selectedRate?.discount_percentage}% OFF</div>}
          <div className="text-lg font-medium capitalize">{!["active", "canceled"].includes(plan?.subscription_status) && ["pending"].includes(plan?.payment_status) ? "Not Billed Yet" : `Billed ${plan?.subscription?.recurring_type}ly`}</div>
          <div className="flex items-center justify-between">
            <div className="text-lg text-yellow-600">
              {pricePerInterval}
              <span className="pl-0.5 text-base">/month</span>
            </div>
            <div>
              Total: {formatCurrency(discountedPrice)}
              {selectedRate?.discount_amount > 0 && <span className="ml-1 text-slate-500 line-through">{formatCurrency(totalPrice)}</span>}
            </div>
          </div>
        </div>

        {!isUpcoming && plan?.subscription_status !== "pending" && (
          <div className="mt-4 flex flex-col gap-4 pb-2">
            <div className="flex items-center justify-between gap-4 text-lg">
              <h3 className="font-semibold">{["canceled", "expired", "on_trial", "on_trial_expired"].includes(plan?.subscription_status) ? (moment(plan?.end_date).isSameOrAfter(moment(), "day") ? "Expiring on:" : "Expired on:") : "Next Billing Date"}</h3>
              <div className="flex items-center justify-center gap-1 font-medium text-gray-600">
                <CalendarIcon className="h-6 w-6" />
                {moment(plan?.end_date)
                  .add(["canceled", "expired", "on_trial", "on_trial_expired"].includes(plan?.subscription_status) ? 0 : 1, "days")
                  .format("MMM DD, YYYY")}
              </div>
            </div>
          </div>
        )}
        {isUpcoming && (
          <InformationAlert
            content={
              <div className="flex flex-wrap space-x-1">
                {isUpcoming && plan?.payment_status === "succeeded" ? <>The user has resubscribed to the plan</> : <>The user's plan has been updated</>}, and the next billing date is
                <div className="flex items-center justify-center gap-1 font-semibold">
                  <CalendarIcon className="h-6 w-6" />
                  {moment(plan?.start_date).format("MMM DD, YYYY")}
                </div>
              </div>
            }
            type="info"
          />
        )}
      </div>
    </div>
  );
};
